import { useSelector, TypedUseSelectorHook } from 'react-redux';

import { RootState } from './main';

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
